<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Analise e consolidado dos instrumentos pedagógicos
        </h1>
      </v-col>
    </v-row>
    <v-row class="d-flex align-center">
      <v-col cols="2">
        <v-card-text class="d-flex align-center">
          <v-icon medium class="mr-2">mdi mdi-file-table</v-icon>
          <h4>Relatórios:</h4>
        </v-card-text>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn @click="() => relatorioAcompanhamento()" block small class="primary">
          <span class="">Ficha de analise e consolidado dos instrumentos pedagógicos</span>
          <v-icon right>mdi mdi-download </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" class="d-flex mb-2 pt-0 pb-0">
        <div class="ml-auto">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Procurar"
            single-line
            hide-details
          >
          </v-text-field>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="professoresList"
          :loading="carregandoProfessores"
          :items-per-page="10"
          hide-default-footer
          no-data-text="Nenhum professor encontrado."
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr v-for="professor in items" :key="professor.id">
                <td>{{ professor.id }}</td>
                <td>{{ professor.nome ? professor.nome : "- - -" }}</td>
                <td>
                  <div class="text-center">
                    <v-menu :close-on-content-click="false" :nudge-width="100" offset-x>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn x-small color="indigo" dark v-bind="attrs" v-on="on"> AÇÕES </v-btn>
                      </template>

                      <v-card class="mx-auto" max-width="430">
                        <v-list>
                          <v-list-item>
                            <v-list-item-avatar color="primary">
                              <v-list-item-title style="color: #fff">
                                {{ professor.nome ? professor.nome.charAt(0).toUpperCase() : "P" }}
                              </v-list-item-title>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ professor.nome ? professor.nome : "- - -" }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-divider></v-divider>

                        <v-list>
                          <v-list-item-group v-if="!professor.estaDeletado" color="primary">
                            <v-list-item
                              :to="{
                                name: 'acompanhamentosAnaliseEConsolidados.newEdit',
                                params: {
                                  professorId: professor.id,
                                },
                              }"
                            >
                              <v-list-item-icon>
                                <v-icon medium>mdi mdi-human-male-board-poll</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>
                                  Lançar analise e consolidado<br />dos instrumentos pedagógicos
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="handlePageChange"
          :search="search"
        >
        </e-paginate>
      </v-col>
    </v-row>

    <e-escolha-disciplina
      @status="abrirModalEscolha = $event"
      :dialog="abrirModalEscolha"
      :gestaoDeAulasId="gestaoDeAulasEscolhida"
      :disciplinas="disciplinasArray"
      :typeModel="typeModel"
    ></e-escolha-disciplina>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import GestaoDeAula from "@/Models/GestaoDeAula";

export default {
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  data() {
    return {
      typeModel: null,
      search: localStorage.getItem("acompanhamentosAnaliseEConsolidado_search") || "",
      professoresList: [],
      pageNumber:
        parseInt(localStorage.getItem("acompanhamentosAnaliseEConsolidado_current_page"), 10) || 1,
      carregandoProfessores: false,
      paginate: {
        current_page:
          parseInt(localStorage.getItem("acompanhamentosAnaliseEConsolidado_current_page"), 10) ||
          1,
        last_page: 1,
      },
      abrirModalEscolha: false,
      table: {
        headers: [
          {
            text: "#",
            value: "id",
          },

          {
            text: "Professor",
            value: "nome",
          },
          {
            text: "",
            value: "actions",
            sortable: false,
            width: "200px",
          },
        ],
      },
      disciplinasArray: [],
      gestaoDeAulasEscolhida: null,
    };
  },
  async mounted() {
    this.$loaderService.open("Carregando acompanhamentos");
    try {
      // await this.listarProfessores(this.pageNumber);
      await this.listarProfessores(this.pageNumber, this.search);
    } catch (error) {
      this.$handleError(error);
    }
    this.$loaderService.close();
  },
  watch: {
    carregandoProfessores(value) {
      if (value && this.professoresList.length === 0) {
        this.$loaderService.open("Carregando acompanhamentos");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      localStorage.setItem("acompanhamentosAnaliseEConsolidado_search", val); // Corrigido aqui
      if (val.length > 2) {
        await this.listarProfessores(0, val);
      }
      if (!val) {
        await this.listarProfessores(0);
      }
    },
  },
  methods: {
    escolherDisciplina(idGestao, disciplinas, type) {
      this.abrirModalEscolha = true;
      this.disciplinasArray = disciplinas;
      this.gestaoDeAulasEscolhida = idGestao;
      this.typeModel = type;
    },
    goBack() {
      if (this.user.role.name.includes("professor")) {
        this.$router.push({
          name: "acessoProfessor.home",
        });
      }
      this.$router.push({
        name: "home",
      });
    },
    async listarProfessores(pageNumber, query = null) {
      this.carregandoProfessores = true;
      try {
        const response = await this.$services.acompanhamentosService.syncAllProfessoresFranquia(
          pageNumber,
          query
        );
        this.professoresList = await response.professores.data;
        this.paginate = response.professores;
      } catch {
        this.carregandoProfessores = false;
      }
      this.carregandoProfessores = false;
    },
    async relatorioAcompanhamento() {
      this.carregandoProfessores = true;
      try {
        await this.$services.acompanhamentosService.relatorioAcompanhamentoAnaliseEConsolidado(
          parseInt(this.user.configuracao_id, 10)
        );
      } catch {
        this.carregandoProfessores = false;
      }
      this.carregandoProfessores = false;
    },
    handlePageChange(page) {
      this.listarProfessores(page, this.search);
      this.pageNumber = page;
      localStorage.setItem("acompanhamentosAnaliseEConsolidado_current_page", page);
    },
  },
};
</script>

<style></style>
